import React from 'react';
import colors from 'constants/colors';

const ArrowSeeAll = ({ color = '$fmDefaultIcons' }) => (
    <svg viewBox={`0 0 18 18`} xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.707 8.248L9.945 5.486c-.263-.263-.25-.702.03-.98.278-.28.718-.293.98-.03l4.099 4.099c.13.129.192.301.189.476a.652.652 0 0 1-.19.476l-4.097 4.098c-.263.263-.703.25-.982-.029-.279-.278-.292-.718-.029-.98l2.866-2.867c-.423-.003-.829-.018-1.703-.055-.549-.024-.83-.035-1.153-.044-3.57-.097-5.217.492-5.727 2.532a.75.75 0 0 1-1.456-.364C3.514 8.85 5.79 8.036 9.996 8.151c.333.009.62.02 1.177.044.772.034 1.169.048 1.534.053z"
            fill={colors[color] ? colors[color] : '#788590'}
            fillRule="nonzero"
        />
    </svg>
);

export default ArrowSeeAll;
